const $ = jQuery.noConflict();

const showMenu = () => {
	// Cache DOM
	const body = $('body');
	const header = body.find('header.header');
	const menuBtn = header.find('.header__menu-btn');
	const menu = body.find('.menu-main');
	const socials = menu.find('.socials__item');
	const navItems = menu.find('#menu-main-nav > li.menu-item');
	const navAsideItems = menu.find('#menu-aside-nav > li.menu-item');
	const logo = header.find('.header__logo');

	// Functions
	function assignDelays() {
		// Socials
		$(socials.get().reverse()).each(function (i) {
			const delay = `${(4 + i) * 90}ms`;
			$(this).attr('data-delay-in', delay);
			$(this).css('transition-delay', $(this).data('delay-in'));
		});
		socials.each(function (i) {
			const delay = `${i * 70}ms`;
			$(this).attr('data-delay-out', delay);
		});
		// Nav Items
		navItems.each(function (i) {
			const delay = `${(4 + i) * 80}ms`;
			$(this).attr('data-delay-in', delay);
			$(this).css('transition-delay', $(this).data('delay-in'));
		});
		$(navItems.get().reverse()).each(function (i) {
			const delay = `${i * 50}ms`;
			$(this).attr('data-delay-out', delay);
		});
		// Aside Nav Items
		navAsideItems.each(function (i) {
			const delay = `${(4 + i) * 120}ms`;
			$(this).attr('data-delay-in', delay);
			$(this).css('transition-delay', $(this).data('delay-in'));
		});
		$(navAsideItems.get().reverse()).each(function (i) {
			const delay = `${i * 120}ms`;
			$(this).attr('data-delay-out', delay);
		});
	}

	function setNewDelays() {
		setTimeout(() => {
			if (body.hasClass('menu-opened')) {
				socials.each(function () {
					$(this).css('transition-delay', $(this).data('delay-out'));
				});
				navItems.each(function () {
					$(this).css('transition-delay', $(this).data('delay-out'));
				});
				navAsideItems.each(function () {
					$(this).css('transition-delay', $(this).data('delay-out'));
				});
			} else {
				socials.each(function () {
					$(this).css('transition-delay', $(this).data('delay-in'));
				});
				navItems.each(function () {
					$(this).css('transition-delay', $(this).data('delay-in'));
				});
				navAsideItems.each(function () {
					$(this).css('transition-delay', $(this).data('delay-in'));
				});
			}
		}, 600);
	}

	function adjustHeaderColor() {
		if (body.hasClass('menu-opened')) {
			body.addClass('noscroll');
			header.addClass('header--menu-open');
			setTimeout(() => {
				logo.addClass('header__logo--white-menu');
			}, 200);
		} else {
			menuBtn.addClass('menu-btn--menu-opened');
			setTimeout(() => {
				logo.removeClass('header__logo--white-menu');
			}, 500);
			setTimeout(() => {
				menuBtn.removeClass('menu-btn--menu-opened');
			}, 800);
			setTimeout(() => {
				body.removeClass('noscroll');
				header.removeClass('header--menu-open');
			}, 1100);
		}
	}

	function disableScrollify() {
		if(body.hasClass('menu-opened')) {
			$.scrollify.disable();
		} else {
			$.scrollify.enable();
		}
	}

	// Main function
	function toggleMenu() {
		body.toggleClass('menu-opened');
		adjustHeaderColor();
		setNewDelays();
		disableScrollify();
	}

	assignDelays();

	// Bind events
	menuBtn.on('click', toggleMenu);
};

export default showMenu;
